import { handleCustomUDL } from "@utils/UDLUtils";

export class TagList {
  private el: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
  }

  init(): void {
    const signal = this.abortController.signal;

    this.el.addEventListener(
      "click",
      (e) => {
        const target = e.target as Element | null;
        const link = target?.closest("a") as HTMLAnchorElement | null;
        if (link) this.handleTagUDL(link);
      },
      { signal },
    );
  }

  private handleTagUDL(link: HTMLAnchorElement): void {
    const text = link.text;
    const url = link.href;

    if (!text || !url) return;

    handleCustomUDL("youtooth_detail_category_overview_click", {
      link_text: text.trim(),
      link_url: url,
    });
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="tag-list"]')
      .forEach((el) => {
        new TagList(el).init();
      });
  }
}
